import {
  FC,
  useState,
  useEffect,
  createContext,
  useContext,
  useRef,
  Dispatch,
  SetStateAction,
} from 'react'
import {LayoutSplashScreen} from '../../../../_metronic/layout/core'
import {AuthModel, UserModel} from './_models'
import * as authHelper from './AuthHelpers'
import {getUserByToken} from './_requests'

import { useDispatch } from "react-redux";
import { User } from "oidc-client";
import authService from "../../../../data/oidc/AuthService";
import { handleLogin, handleLogout } from "../../../../data/redux/coreActions";

import toast from 'react-hot-toast';
import { overrideToastDefaults, toastMessages } from "../../../../data/toastDefaults"
import { jwtDecode } from "jwt-decode"
import { get } from '../../../../utils/ajax'
import { APIM_VERSION, remoteRoutes } from '../../../../data/constants'
import { coreConstants } from '../../../../data/redux/coreReducer'

type AuthContextProps = {
  auth: AuthModel | undefined
  saveAuth: (auth: AuthModel | undefined) => void
  currentUser: UserModel | undefined
  setCurrentUser: Dispatch<SetStateAction<UserModel | undefined>>
  logout: () => void
}

const initAuthContextPropsState = {
  auth: authHelper.getAuth(),
  saveAuth: () => {},
  currentUser: undefined,
  setCurrentUser: () => {},
  logout: () => {},
}

const AuthContext = createContext<AuthContextProps>(initAuthContextPropsState)

const useAuth = () => {
  return useContext(AuthContext)
}

const AuthProvider: FC = ({children}) => {
  const dispatch = useDispatch();
  const [auth, setAuth] = useState<AuthModel | undefined>(authHelper.getAuth())
  const [currentUser, setCurrentUser] = useState<UserModel | undefined>()

  const saveAuth = (auth: AuthModel | undefined) => {
    setAuth(auth)
    if (auth) {
      authHelper.setAuth(auth)
    } else {
      authHelper.removeAuth()
    }
  }

  const logout = async () => {
    saveAuth(undefined)
    setCurrentUser(undefined)
    dispatch(handleLogout());
    await authService.logout();
  }

  return (
    <AuthContext.Provider value={{auth, saveAuth, currentUser, setCurrentUser, logout}}>
      {children}
    </AuthContext.Provider>
  )
}

const AuthInit: FC = ({children}) => {

  const dispatch = useDispatch();
  const {auth, logout, setCurrentUser} = useAuth()
  const [showSplashScreen, setShowSplashScreen] = useState(true)

  useEffect(() => {

    authService
    .getUser()
    .then((user: User | null) => {

      let TOKEN:any = {}
      if (user) {
        TOKEN = jwtDecode(user.access_token)
      }
      
      if (user && !user.expired) {
        if(user.profile) { //REFACTOR CHECK FOR ROLE

          if (user.profile && user.profile?.tenantid) {
            
            dispatch(handleLogin({ user: user.profile, token: user.access_token, roles: TOKEN?.realm_access?.roles }));
            //REFACTOR THIS
            const data = {"id":2,"first_name":"German","last_name":"","email":"admin@demo.com","username":"2022-07-14T11:37:39.000000Z","password":"2022-07-14T11:37:39.000000Z","updated_at":"2022-07-14T11:37:39.000000Z","api_token":"$2y$10$lzYGs3CVjxdlR2ERLfZOyezaXM8qXLGd5fHEkjoBmDxznEl.CvAdC"}
            if(user.profile.name && user.profile.email) {
              data.first_name = user.profile.name
              data.email = user.profile.email
            }
            setCurrentUser(data)
            setShowSplashScreen(false)
          } else {
            toast.success(toastMessages.Login.inValidAccount, overrideToastDefaults );
            logout()
          }
        } else {
          toast.success(toastMessages.Login.inValidAccount, overrideToastDefaults );
        }
        
      } else {
        setShowSplashScreen(false)
      }
    })

  }, [])

  return showSplashScreen ? <LayoutSplashScreen /> : <>{children}</>
}

export {AuthProvider, AuthInit, useAuth}
